import loadable from '@loadable/component';
import { MEMBERPAGES_URL } from '@lib/constants';

export const customizeCookiesPath = '/administrer-cookies';
export const CustomizeCookies = loadable(() => import('../../pages/cookies/customize'), {
  resolveComponent: (m) => m.CustomizeCookies,
});

export const cookieDeclarationPath = '/cookies';
export const CookieDeclaration = loadable(() => import('../../pages/cookies/declaration'), {
  resolveComponent: (m) => m.CookieDeclaration,
});

export const idpReceiptPath = '/kvittering-internasjonalt-forerkort/:orderId';
export const IdpReceipt = loadable(() => import('../../pages/internationalDrivingPermit/components/Receipt/Receipt'), {
  resolveComponent: (m) => m.IdpReceipt,
});

export const orderReceiptPath = '/ordre-kvittering/:paymentId';
export const OrderReceipt = loadable(() => import('../../pages/MyMembership/OrderReceipt/OrderReceipt'), {
  resolveComponent: (m) => m.OrderReceipt,
});

export const welcomePath = '/velkommen-som-medlem/:orderId';
export const Welcome = loadable(() => import('../../pages/Welcome'), { resolveComponent: (m) => m.Welcome });

export const paymentCancelledPath = '/betaling-kansellert/:orderId';
export const PaymentCancelled = loadable(() => import('../../pages/PaymentCancelled'), {
  resolveComponent: (m) => m.PaymentCancelled,
});

export const idpArticlePath = `/internasjonalt-forerkort`;
export const IdpArticle = loadable(
  () => import('../../pages/internationalDrivingPermit/article/InternationalDrivingPermitArticle'),
  { resolveComponent: (m) => m.IdpArticle },
);

export const Chat = loadable(() => import('../../components/Chat'), { resolveComponent: (m) => m.Chat });

export const becomeAMemberPath = '/bli-medlem';
export const BecomeAMember = loadable(() => import('../../pages/BecomeAMember'), {
  resolveComponent: (m) => m.BecomeAMember,
});

export const buyIdpPath = '/bestill-internasjonalt-forerkort';
export const BuyInternationalDrivingPermit = loadable(
  () => import('../../pages/internationalDrivingPermit/InternationalDrivingPermit'),
  { resolveComponent: (m) => m.BuyInternationalDrivingPermit },
);

export const frontPagePath = '/';
export const FrontPage = loadable(() => import('../../pages/FrontPage/FrontPage'), {
  resolveComponent: (m) => m.FrontPage,
});

export const bilGuideRouterPath = '/bilguiden';
export const BilGuideRouter = loadable(() => import('../../routers/BilGuideRouter'), {
  resolveComponent: (m) => m.BilGuideRouter,
});

export const consumerTestRouterPath = '/forbrukertester/:slug';
export const ConsumerTestRouter = loadable(() => import('../../routers/ConsumerTestRouter'), {
  resolveComponent: (m) => m.ConsumerTestRouter,
});

export const articleTestPagePath = '/testartikkel';
export const ArticleTestPage = loadable(() => import('../../pages/ArticleTestPage/ArticleTestPage'));

export const loggingInPath = '/nafid/login';
export const LoggingIn = loadable(() => import('../../pages/LoggingIn/LoggingIn'), {
  resolveComponent: (m) => m.LoggingIn,
});

export const loggedOutPath = '/nafid/logout';
export const LoggedOut = loadable(() => import('../../pages/LoggedOut/LoggedOut'), {
  resolveComponent: (m) => m.LoggedOut,
});

export const internalServerErrorPath = '/500';
export const InternalServerError = loadable(
  () => import('../../pages/errors/InternalServerError/InternalServerError'),
  { resolveComponent: (m) => m.InternalServerError },
);

export const myProfileRouterPath = `/${MEMBERPAGES_URL}`;
export const MyProfileRouter = loadable(() => import('../../routers/MyProfileRouter'), {
  resolveComponent: (m) => m.MyProfileRouter,
});

export const qrLandingPagePath = '/qr/:qrId';
export const QrLandingPage = loadable(() => import('../../pages/QrLandingPage/QrLandingPage'), {
  resolveComponent: (m) => m.QrLandingPage,
});

export const loginPath = '/naf/auth';
export const Login = loadable(() => import('../../pages/Login/Login'), { resolveComponent: (m) => m.Login });
